<template>
  <div class="mx-auto pt-[5rem] max-w-screen-xl  w-full pb-[2.1rem] ">
    <div class="">
      <div class="w-full flex justify-center ">
        <div class=" bg-white   flex-col  flex px-4  h-[70px] justify-around  items-center ">


          <div class="flex flex-col items-center ">
            <div class="text-[#212121] text-center capitalize text-[22px] leading-[24px] font-[400] font-roboto ">
              {{ agency.name }}
            </div>
            <div class="text-[#BDBDBD] text-[15px] font-[400] leading-[20px] font-roboto">
              {{ agency.responsable?.email }}
            </div>
          </div>
          <div class="">
            <AtomSpinner v-if='loading' />
          </div>
        </div>
      </div>

      <!-- Navigation -->
      <div class="mb-8">
        <NavigationInternNavbar :origin="'agency'" />
      </div>

      <!-- Main Content -->
      <div class="grid grid-cols-1  gap-8">
        <!-- Agency Information Card -->
        <div class="">
          <div class="bg-white rounded-xl shadow-lg p-8">
            <div class="flex flex-col sm:flex-row sm:justify-between sm:items-start mb-6">
              <div>
                <h2 class="text-2xl font-semibold text-gray-900 mb-2">{{ $t('agencyInformation') }}</h2>
                <p class="text-gray-600">{{ $t('agencyInformationDesc') }}</p>
              </div>
              <Button
                v-if="RoleIndex(UserProfile()?.roles) === RoleCategory.ADMIN"
                icon="pi pi-pencil"
                :label="$t('editAgency')"
                class="p-button-outlined mt-4 sm:mt-0"
                @click="showEditModal = true"
              />
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              <!-- Nom de l'agence -->
              <div class="bg-gray-50 rounded-lg p-4">
                <label class="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
                  <i class="pi pi-building text-blue-500"></i>
                  {{ $t('agencyName') }}
                </label>
                <div class="text-gray-900 font-medium">{{ agency.name || $t('notProvided') }}</div>
              </div>

              <!-- Pays -->
              <div class="bg-gray-50 rounded-lg p-4">
                <label class="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
                  <i class="pi pi-globe text-green-500"></i>
                  {{ $t('country') }}
                </label>
                <div class="text-gray-900 font-medium">{{ agency.country?.name || $t('notProvided') }}</div>
              </div>

              <!-- Adresse -->
              <div class="bg-gray-50 rounded-lg p-4 md:col-span-2">
                <label class="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
                  <i class="pi pi-map-marker text-teal-500"></i>
                  {{ $t('address') }}
                </label>
                <div class="text-gray-900 font-medium">{{ agency.address || $t('notProvided') }}</div>
              </div>

              <!-- Code postal -->
              <div class="bg-gray-50 rounded-lg p-4">
                <label class="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
                  <i class="pi pi-envelope text-orange-500"></i>
                  {{ $t('postalCode') }}
                </label>
                <div class="text-gray-900 font-medium">{{ agency.postalCode || $t('notProvided') }}</div>
              </div>

              <!-- Responsable -->
              <div class="bg-gray-50 rounded-lg p-4">
                <label class="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
                  <i class="pi pi-user text-purple-500"></i>
                  {{ $t('responsible') }}
                </label>
                <div class="text-gray-900 font-medium">
                  <div v-if="agency.responsable" class="flex items-center gap-3">
                    <div>
                      <div>{{ agency.responsable.firstName }} {{ agency.responsable.lastName }}</div>
                      <div class="text-sm text-gray-600">{{ agency.responsable.email }}</div>
                    </div>
                  </div>
                  <div v-else class="text-gray-600">{{ $t('notAssigned') }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

      
      </div>

      <!-- Edit Modal -->
      <Dialog
        v-model:visible="showEditModal"
        header="Modifier l'agence"
        :modal="true"
        :style="{ width: '90vw', maxWidth: '900px' }"
        :closable="true"
        class="rounded-xl shadow-2xl bg-white"
      >
        <div class="p-6">
          <MoleculeFormAgencyAdd :data="agency" :action="'update'" @agencyAdd="onAgencyUpdated" :key="modalKey" />
        </div>

        <template #footer>
          <div class="flex justify-end gap-3 p-4 bg-gray-50 rounded-b-xl">
            <Button label="Annuler" icon="pi pi-times" class="p-button-text" @click="closeEditModal" />
          </div>
        </template>
      </Dialog>
    </div>
  </div>
</template>
<script lang="ts">
import Dialog from 'primevue/dialog';

interface Agency {
  name?: string;
  responsable?: {
    email?: string;
    firstName?: string;
    lastName?: string;
  };
  country?: {
    name?: string;
  };
  address?: string;
  postalCode?: string;
  countryId?: string;
  delegatesCount?: number;
  productsCount?: number;
  sectorsCount?: number;
  [key: string]: any;
}

export default {
  name: "AgencyDetails",
  components: {
    Dialog
  },
  data() {
    return {
      agency: {} as Agency,
      tabkey: 124,
      loading: false,
      showEditModal: false,
      modalKey: 0
    };
  },
  setup() {
    definePageMeta({ title: 'AgencyDetails', layout: "default", middleware: ["auth"] });
    useSeoMeta({
      title: 'AgencyDetails'
    });
  },
  mounted() {
    this.$nextTick(() => {
      this.getAgency(this.$router.currentRoute.value.query.agency_id as string);
    });
  },
  methods: {
    getAgency(agencyId: string): void {
      this.loading = true;
      GetAgency(agencyId)
        .then((res) => {
          this.loading = false;
          this.agency = res;
          this.tabkey++;
          useState('agencyCountryId', () => this.agency.countryId);
          localStorage.setItem('agency', JSON.stringify(this.agency));
        })
        .catch((error) => {
          this.loading = false;
          ErrorAlert(error);
        });
    },

    onAgencyUpdated(success: boolean) {
      if (success) {
        // Recharger les données de l'agence
        this.getAgency(this.$router.currentRoute.value.query.agency_id as string);

        // Fermer la modal
        this.closeEditModal();

        // Afficher un message de succès
        SuccessAllert("Agence mise à jour avec succès");
      }
    },

    closeEditModal() {
      this.showEditModal = false;
      // Incrémenter la clé pour forcer le re-render du composant de formulaire
      this.modalKey++;
    }
  }
};
</script>